import React from "react";
import { ActionButtonProps } from "../../types/general/TActionButtonProps";

const PrintButton: React.FC<ActionButtonProps> = ({
  fill,
  id,
  actionHandler,
  disabled,
}) => {
  return (
    <svg
      className={`${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
      onClick={disabled ? () => {} : () => actionHandler(id)}
      style={{
        marginRight: "8px",
        cursor: "pointer",
      }}
      width="24"
      height="24"
      viewBox="0 -2 25 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Background shape with same opacity/style as EditButton */}
      <path
        opacity="0.4"
        d="M13.5 22H7a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v.5"
        stroke="#002C76"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Main printer body */}
      <path
        d="m16 19 2 2 4-4"
        stroke="#002C76"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Paper tray */}
      <path
        d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2"
        stroke="#002C76"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Printer top/front */}
      <path
        d="M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6"
        stroke="#002C76"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PrintButton;
